import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-471ce180"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layout-container" }
const _hoisted_2 = { class: "main-container" }

import MenuBar from '@/components/layouts/MenuBar.vue'
import TopBar from '@/components/layouts/TopBar.vue'
import FooterBar from '@/components/layouts/FooterBar.vue'
import useWindowWidth from '@/composables/useWindowWidth'


export default /*#__PURE__*/_defineComponent({
  __name: 'DefaultLayout',
  setup(__props) {

const {windowWidth} = useWindowWidth()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TopBar),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(MenuBar),
      _createElementVNode("main", {
        class: _normalizeClass({animate:true, main:_unref(windowWidth)>950, mainmobile:_unref(windowWidth)<=950})
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 2)
    ]),
    _createVNode(FooterBar)
  ]))
}
}

})